<template>
	<div v-if="text" class="ui-tooltip" :class="[ { 'has-title': title }, orientation ]" v-bg="'tooltip.png'">
		<ui-text v-if="title" class="title" :text="title" :value="value" v-bg="'tooltip-title.png'" />
		<ui-text v-if="text" class="description" :text="text" :value="value" />
	</div>
</template>

<script>
import UiText from '@/components/ui/ui-text'

export default {
	name: 'ui-tooltip',
	props: {
		title: { default: '' },
		text: { default: '' },
		value: { default: null },
		orientation: { default: 'top' }
	},
	components: { UiText }
}
</script>

<style lang="stylus" scoped>

.ui-tooltip
	position absolute
	width 280px
	background center center no-repeat
	background-size 100% 100%
	padding 24px
	color #fff
	text-align center
	z-index 10
	font-size 2.8rem
	visibility hidden
	transform translateX(-50%)
	&.top
		left 50%
		bottom calc(100% + 4px)
	&.right
		left calc(100% + 8px)
		top 50%
		transform translateY(-50%)
		&:before
			display none
	&.bottom
		left 50%
		top calc(100% + 40px)
		// transform none
		&:before
			display none
	&.has-title
		padding-top 32px
	&:hover
		visibility visible !important
		display block !important
	&:before
		content ''
		position absolute
		left 0
		right 0
		height 16px
		bottom -@height
		width 100%
	.title
		position absolute
		bottom 100%
		left 50%
		padding 8px
		min-width 70%
		background center center no-repeat
		background-size 100% 100%
		border-radius 4px
		color dark
		font-size 3.2rem
		line-height 0.7em
		box-shadow 0 2px 2px alpha(#000, 50%)
		transform translate(-50%, 50%)

</style>
